import React from 'react';
import logo from './images/logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1 className="Inter-semibold">
          UrbanHawk
        </h1>
      </header>
    </div>
  );
}

export default App;
